<template>
  <div class="login">
    <div class="login_title">
      <div class="login_title_logo"></div>
      <div class="login_title_word">创作者服务平台</div>
    </div>
    <CertifyBox></CertifyBox>
    <div class="login_bottom">
      <div class="login_bottom_logo"></div>
      <div class="login_bottom_word">
        Copyright 2015 - {{ date }} Mini World. All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
import CertifyBox from '@/components/CertifyBox.vue';
import { mapState } from 'vuex';
export default {
  components: {
    CertifyBox,
  },
  data() {
    return {
      date: 2022,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let date = new Date(this.userInfo.st * 1000).getFullYear();
      if (date) {
        this.date = date;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: url('../assets/images/login_bac.png') no-repeat;
  background-size: cover;
}

.login_title {
  position: absolute;
  top: 40px;
  left: 40px;
  display: flex;
  height: 48px;

  .login_title_logo {
    background: url('../assets/images/logo_white.svg') no-repeat;
    background-size: 144px 48px;
    width: 144px;
    height: 48px;
  }

  .login_title_word {
    font-size: 20px;
    font-weight: 400;
    line-height: 48px;
    margin-left: 16px;
    color: rgba(255, 255, 255, 1);
  }
}
.init_btn {
  position: absolute;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
  left: 920px;
  top: 624px;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}

.login_type {
  font-size: 14px;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  text-decoration: none;
  display: block;
  left: 242px;
  top: 24px;
  position: relative;
}
.login_bottom {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
  .login_bottom_logo {
    background: url('../assets/images/logo.svg') no-repeat;
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
    float: left;
  }
  .login_bottom_word {
    line-height: 29px;
    color: rgba(255, 255, 255, 1);
    margin-left: 24px;
    font-size: 16px;
    text-align: center;
    float: left;
  }
}
</style>
